.me-widget-placement {
  // We need to reserve space to prevent layout shift.
  // Its a best practice to center content vertically.
  // This makes white space appear less disturbing.
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;

  // Reserve space to prevent layout shift.
  // 250px should be fine in most cases.
  // Placements below the fold are not relevant for CLS.
  &--above-the-fold {
    min-height: 250px;
  }

  // Fade in asynchronously loaded content
  &--loading &__content {
    opacity: 0;
  }

  &__content {
    // The 150ms delay improves the user experience.
    // The widget is usually rendered at that point…
    transition: opacity 150ms linear 150ms;
  }
}
